import React from 'react';

export default function ButtonViewer(props) {
  return (
    <button {...props}>
      {props.children}
    </button>
  )
}